import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { ClasseConsumo } from '../../components'
import * as classeConsumoActionCreators from '../../redux/modules/classeConsumo'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class ClasseConsumoContainer extends Component {

  static propTypes = {
    history: PropTypes.object,
    multipleClasseConsumo: PropTypes.object,
    fetchMultipleClasseConsumo: PropTypes.func,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    destroyClasseConsumo: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    await this.props.fetchMultipleClasseConsumo()
  }

  handleRedirectToNew = () => {
    this.props.history.push('/classes_consumo/new')
  }

  handleEditResource = (id) => {
    this.props.history.push(`/classes_consumo/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyClasseConsumo(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('classeConsumo', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('classeConsumo', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleClasseConsumo.toList().toJSON(),
      'uf',
      ['id', 'nome', 'descricao'],
    )
  }

  render () {
    return (
      <ClasseConsumo
        onRedirectToNew={this.handleRedirectToNew}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        multipleClasseConsumo={this.props.multipleClasseConsumo}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading}  />
    )
  }
}

function mapStateToProps ({classeConsumo, status, sort, filter}) {
  const sortColumn = sort.getIn(['classeConsumo', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['classeConsumo', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['classeConsumo', 'filterText']) || ''

  let map = filterMap(classeConsumo, ['nome', 'descricao'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleClasseConsumo: map,
    error: status.getIn(['classeConsumo', 'error']),
    isLoading: status.getIn(['classeConsumo', 'isLoading']),
    sortColumn,
    sortDirection,
    filterText,
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...classeConsumoActionCreators,
    ...flashMessageAcionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ClasseConsumoContainer)
